module.exports = __webpack_public_path__ + "media/images/icon-time-e89159e363b485e0019f28aa0bcea154.svg";